import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "./../services/api";

export const useBookingData = (formData, setFormData, setSubjects, setTutors, setEnforceAvailability) => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState({
    form: false,
    tutors: false,
    subjects: false,
  });

  const loadSubjects = useCallback(async () => {
    setLoading((prev) => ({ ...prev, subjects: true }));
    try {
      const { subjects = [] } = await api.get("/subjects");
      setSubjects(subjects);
    } catch (err) {
      toast.error("Failed to load subjects");
    } finally {
      setLoading((prev) => ({ ...prev, subjects: false }));
    }
  }, []);

  const loadSettings = useCallback(async () => {
    try {
      const { settings } = await api.get("/public/settings");
      setEnforceAvailability(Boolean(settings?.enforceAvailability));
    } catch (err) {
      console.error("Settings load failed:", err);
    }
  }, []);

  const loadTutors = useCallback(async () => {
    if (!formData.subjectId) return;
    setLoading((prev) => ({ ...prev, tutors: true }));
    try {
      const { tutors = [] } = await api.get(`/tutors?subject=${formData.subjectId}`);
      setTutors(tutors);
    } catch (err) {
      toast.error("Failed to load tutors");
    } finally {
      setLoading((prev) => ({ ...prev, tutors: false }));
    }
  }, [formData.subjectId]);

  // Effects
  useEffect(() => {
    loadSubjects();
    loadSettings();
  }, [loadSubjects, loadSettings]);

  useEffect(() => {
    const tutorId = searchParams.get("tutorId");
    if (tutorId) {
      setFormData((prev) => ({
        ...prev,
        selectedTutorIds: [tutorId],
      }));
    }
  }, [searchParams]);

  return {
    loading,
    setLoading,
    loadSubjects,
    loadSettings,
    loadTutors,
  };
};
